module.exports = __webpack_public_path__ + "img/image5.925e5305.png";